export default __webpack_public_path__ + "b7d77d73e88221ee337cbe65fcf6d74a.png";